import { FC } from 'react';
import AmwayBusinessLinksItem from './AmwayBusinessLinksItem';
import type { AmwayBusinessLinksItemProps, AmwayBusinessLinksProps } from './types/propsTypes';
import styles from './AmwayBusinessLinks.module.scss';

const AmwayBusinessLinks: FC<AmwayBusinessLinksProps> = ({ quickLinksData, title }) => (
  <div className={styles['amway-business-link-container']} data-testid={'amway-business-link-test-id'}>
    <div className={styles['amway-business-link-wrapper']}>
      <h2 className={styles['title-section']}>{title}</h2>
      <div className={styles['amway-business-link-items-section']}>
        {quickLinksData.map((item: AmwayBusinessLinksItemProps) => (
          <AmwayBusinessLinksItem key={`${item.linkdata}`} images={item.images} linkdata={item.linkdata} />
        ))}
      </div>
    </div>
  </div>
);

export default AmwayBusinessLinks;
export type { AmwayBusinessLinksProps };
